export * from '@fhs/routing/src/routes/v2/offers';
export { default } from '@fhs/routing/src/routes/v2/offers';
